import { render, staticRenderFns } from "./systemRole.vue?vue&type=template&id=5d0ae020&scoped=true&"
import script from "./systemRole.vue?vue&type=script&lang=js&"
export * from "./systemRole.vue?vue&type=script&lang=js&"
import style0 from "./systemRole.vue?vue&type=style&index=0&id=5d0ae020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ae020",
  null
  
)

export default component.exports